/* eslint-disable no-empty-pattern */
import companyService from '@/services/company.js';

const initialState = () => {
	return {
		companies: [],
		company: {},
		searchParams: {
			name: '',
			orderBy: 'Name',
			pageSize: 0,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	};
};

const state = initialState();

export default {
	debug: false,
	namespaced: true,
	state,

	mutations: {
		SET_COMPANIES(state, companies) {
			state.companies = companies;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		RESET(state) {
			Object.assign(state, initialState());
		}
	},
	actions: {
		async getCompanies({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await companyService
				.getCompanies(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_COMPANIES', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getCompanies');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting customers: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async getCompaniesByCustomParams({ dispatch }, params) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await companyService
				.getCompanies(params)
				.then(res => {
					dispatch('appStore/setLoading', -1, { root: true });

					return res;
				})
				.catch(err => {
					console.log(err);

					dispatch('appStore/setLoading', -1, { root: true });

					return err;
				});
		},

		async getCompany({ dispatch }, companyId) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await companyService
				.getCompany(companyId)
				.then(res => {
					dispatch('appStore/setLoading', -1, { root: true });

					return res;
				})
				.catch(err => {
					console.log(err);

					dispatch('appStore/setLoading', -1, { root: true });

					return err;
				});
		},

		async createCompany({ dispatch }, company) {
			return await companyService
				.createCompany(company)
				.then(result => {
					dispatch('getCompanies');

					return result;
				})
				.catch(err => {
					console.log('Error creating customer: ', err);
				});
		},

		async updateCompany({ dispatch }, company) {
			return await companyService
				.updateCompany(company)
				.then(result => {
					dispatch('getCompanies');

					return result;
				})
				.catch(err => {
					console.log('Error updating customer: ', err);
				});
		},

		async deleteCompany({ dispatch }, companyId) {
			return await companyService
				.deleteCompany(companyId)
				.then(result => {
					dispatch('getCompanies');

					return result;
				})
				.catch(err => {
					console.log('Error deleting customer: ', err);
				});
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		companies: state => {
			return state.companies;
		},

		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
